module.exports = __webpack_public_path__ + "img/loginLogo1.84158f90.png";